import React from "react"
import { Icon } from "@drifthq/tide-core"
import GREEN_CHECK from "./greenCheck.svg"
import "./style.css"

const renderSuccessNotification = text => (
  <div className="install-notification-wrapper">
    <img
      className="install-notification-success-icon"
      src={GREEN_CHECK}
      alt="green-check"
    />
    <div className="install-notification-success-text">{text}</div>
  </div>
)

const renderErrorNotification = text => (
  <div className="install-notification-wrapper">
    <Icon className="install-notification-error-icon" name="warning-triangle" />
    <div className="install-notification-error-text">{text}</div>
  </div>
)

const InstallNotification = ({
  errorText,
  successText,
  isError,
  isSuccess,
  className
}) => {
  if (!isError && !isSuccess) {
    return null
  }
  return (
    <div className={`${className} install-notification`}>
      {isError && renderErrorNotification(errorText)}
      {isSuccess && renderSuccessNotification(successText)}
    </div>
  )
}

export default InstallNotification



// WEBPACK FOOTER //
// ./src/components/OnboardingInstallNotification/index.js